import {useLocation} from 'react-router-dom';

import {Box} from '@mui/material';

import {ReactComponent as EmpionLogo} from '../../assets/empion.svg';
import {AppConfig} from '../../lib/AppConfig';

export const EmpionLogoWithText = () => {
  const location = useLocation();
  const disableClick = location.pathname.includes('b2b');

  return (
    <Box
      component='a'
      href={disableClick ? undefined : AppConfig.HOME_PATH}
      sx={{
        display: 'flex',
        flexGrow: {xs: 1, md: 0},
        textDecoration: 'none',
        alignItems: 'center',
        '& svg': {
          height: {xs: 22, md: 40},
          width: 'auto',
        },
      }}
    >
      <EmpionLogo />
    </Box>
  );
};
